export const defaultDepartureCityCode = 'ALA';

export const defaultDepartureCityNames = {
  name: 'Алматы',
  name_ru: 'Алматы',
  name_en: 'Almaty',
  name_kk: 'Алматы',
};
